import React from 'react';
import {BoilerTextAreaProps, TextArea} from 'b302-frontend-library';

interface Props<T> extends BoilerTextAreaProps<T> {
    children?: any;
}

function HanTextArea<T>(props: Props<T>) {

    return (
        <div className="han-input">
            {props.children && <div className="han-input__icon">{props.children}</div>}

            <TextArea
                className={'han-input__input'}
                {...props} />
        </div>
    );
}

export default HanTextArea;
